import React, { useState } from 'react'
import BasePopup from '../Popup'
import styled from "styled-components";
import ImageBackground from "../../../../../assets/images/Event-2026/back-winner.png";
import ImageExit from "../../../../../assets/images/Event-2026/exit.png";
import ImageHis from "../../../../../assets/images/Event-2026/his.png";
import ImageInfo from "../../../../../assets/images/Event-2026/info.png";
import ImageWorld from "../../../../../assets/images/Event-2026/title_world.png";
import ImageWorldTBN from "../../../../../assets/images/Event-2026/title_worldTBN.png";
import ImageButtonLeft from "../../../../../assets/images/Event-2026/page-left.png";
import ImageButtonRight from "../../../../../assets/images/Event-2026/btnright.png";
import { Button } from 'antd';
import { getMiniGameListWinnerQuery } from 'dataLayer/miniGame';
import { useQuery } from 'react-query';
import dayjs from "dayjs";
import PopupActivityHis from '../PopupFooter/PopupActivityHis';
import PopupRule from '../PopupFooter/PopupRule';
import { useTranslation } from 'react-i18next';
import { useMiniGameAuth } from '../../store';

export default function Winner({ isOpen = false, setIsOpen, className }) {
	const { t, i18n } = useTranslation()
	const [type, setType] = useState(0);
	const [showHistory, setShowHistory] = useState(false);
	const [showInfo, setShowInfo] = useState(false);
	const { user, isAuthenticated, remainTurn, requireLogin, goToLogin } =
		useMiniGameAuth();
	const { data } = useQuery(getMiniGameListWinnerQuery(type));

	return (
		<>
			<PopupActivityHis
				isShowPopupHistory={showHistory}
				setIsShowPopupHistory={setShowHistory}
			/>

			<PopupRule
				isShowPopupIntro={showInfo}
				setIsShowPopupIntro={setShowInfo}
			/>
			<Container>
				<BasePopup
					visible={isOpen}
					className={className}
					onCancel={() => setIsOpen(false)}
					getContainer
					closable={false}
				>
					<div className='container-winner'>
						<div className='icon'>
							<div>
								<img src={ImageHis} alt='' className='img-his' onClick={() => {
									setIsOpen(false)
									setShowHistory(true)
								}} />
								<img src={ImageInfo} alt='' className='img-info' onClick={() => {
									setIsOpen(false)
									setShowInfo(true)
								}} />
							</div>
							<img src={ImageExit} alt='' className='img-exit' onClick={() => setIsOpen(false)} />
						</div>
						<div className='title'>
							<img src={i18n.language === 'en' ? ImageWorld : ImageWorldTBN} alt='' className='img-world' />
							<p>{t('a_big_congratulations_to')}<div className='icons'>🎉👏</div></p>
						</div>
						<div className="btn mini-tab-popup">
							<div className={`tab-mini-popup tab_left ${type == 0 ? 'tab-popup-active' : ''}`} >
								<div onClick={() => setType(0)}>
									<span className='tab-popup__content'>{t('all_prizes')}</span>
								</div>
							</div>
							<div className={`tab-mini-popup tab_right ${type == 1 ? 'tab-popup-active' : ''}`} >
								<div onClick={() => user ? setType(1) : {}}>
									<span className='tab-popup__content'>{t('your_prizes')}</span>
								</div>
							</div>
						</div>
						<div className="winner-table">
							<table>
								<thead>
									<tr>
										<th>{t('prizes')}</th>
										<th>{t('time')}</th>
										<th>ISDN</th>
									</tr>
								</thead>
							</table>

							<div className="table-body">
								<table>
									<tbody>
										{data?.length > 0 ? (
											data?.map((item, index) => (
												<tr key={index}>
													<td>
														<div className="prize">
															<img src={item?.image} alt="" />
															<span>{item?.name}</span>
														</div>
													</td>

													<td>
														{dayjs(item?.take_time).format("DD/MM/YYYY HH:mm")}
													</td>

													<td>{item?.isdn}</td>
												</tr>
											))
										) : (
											<tr>
												<td colSpan={3} className="no-data">
													{t('no_data')}
												</td>
											</tr>
										)}
									</tbody>
								</table>
							</div>
						</div>
						<div className='description'>
							<p>{t('lego_trophy_prize_description')}</p>
							<p>{t('keep_collecting_the')} 🎁✨</p>
						</div>
					</div>
				</BasePopup>
			</Container>
		</>
	)
}
const Container = styled.div`
.container-winner{
	background-image: url(${ImageBackground});
	background-size: 100% 100%;
	background-position: center;
	background-repeat: no-repeat;
	width: 100%;
	height: 100%;
	min-height: 680px;
	padding: 20px;

	.tab-popup__content{
			font-size: 16px;
				@media (max-width: 768px) {
        			font-size: 12px;
      }
			@media (max-width: 320px) {
        			font-size: 10px;
      }
	}

	.no-data {
		text-align: center;
		padding: 30px 0;
		font-size: 16px;
		font-weight: 600;
		color: #162481;
		height: 100px;
	}

	.icon{
		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: 10px;
		img{
			cursor: pointer;
		}
	}

	.title{
		text-align: center;
		padding: 20px 0;
		p{
			color: #fff;
			font-weight: 700;
			font-size: 18px;
			line-height: 140%;
			margin-bottom: 0;
			padding: 0 45px;
			width: 100%;
			max-width: 463px;
			@media (max-width: 768px) {
        			font-size: 13px;
					padding: 0 20px;
      }
			@media (max-width: 320px) {
        			font-size: 12px;
					padding: 0 10px;
      }
			.icons {
			display: inline;
			white-space: nowrap;
			margin-left: 4px;
			}
		}
	}

 .btn {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    gap: 5px;

    .menu-item {
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center;
      height: 50px;
      cursor: pointer;
      @media (max-width: 768px) {
        height: 45px;
      }

      div {
        display: flex;
        align-items: center;
        span {
          font-size: 17px;
          font-weight: 700;
          color: #fff;
          @media (max-width: 768px) {
            font-size: 14px;
          }
        }
      }
    }

    .menu-item_left {
      background-image: url(${ImageButtonLeft});
      position: absolute;
      left: 20px;
      width: calc(100% - 50%);
      @media (max-width: 768px) {
        left: 10px;
        width: calc(100% - 50%);
      }
      div {
        position: absolute;
        left: 30px;
        top: 50%;
        transform: translateY(-50%);
        @media (max-width: 768px) {
          left: 10px;
        }
        span {
          /* padding-left: 20px; */
          @media (max-width: 768px) {
            padding-left: 10px;
          }
        }
        img {
          @media (max-width: 768px) {
            width: 30px;
            height: 30px;
          }
        }
      }
    }
    .menu-item_right {
      background-image: url(${ImageButtonRight});
      position: absolute;
      right: 20px;
      width: calc(100% - 50%);
      @media (max-width: 768px) {
        right: 10px;
        width: calc(100% - 50%);
      }
      div {
        position: absolute;
        right: 30px;
        top: 50%;
        transform: translateY(-50%);
        @media (max-width: 768px) {
          right: 10px;
        }
        span {
          /* padding-right: 20px; */
          @media (max-width: 768px) {
            padding-right: 10px;
          }
        }
        img {
          @media (max-width: 768px) {
            width: 25px;
            height: 25px;
          }
        }
      }
    }
  }

	.winner-table {
	width: 100%;
	/* border: 2px solid #33b5ff; */
	border-radius: 8px;
	overflow: hidden;
	background: #d9d6f8;
	margin-top: 40px;
	  @media (max-width: 768px) {
            margin-top: 20px;
          }

	table {
		width: 100%;
		table-layout: fixed;
		border-collapse: collapse;
	}

	thead {
		background: #e8e8e8;

		th {
			font-size: 16px;
			font-weight: 500;
			color: #4f5b6b;
			text-align: center;
			padding: 10px 0;

			&:nth-child(1) {
				width: 40%;
			}

			&:nth-child(2) {
				width: 35%;
			}

			&:nth-child(3) {
				width: 25%;
			}
		}
	}

	.table-body {
		max-height: 355px; 
		overflow-y: auto;
		overflow-x: hidden;

		&::-webkit-scrollbar {
			width: 6px;
		}

		&::-webkit-scrollbar-thumb {
			background: rgba(22, 36, 129, 1);
			border-radius: 999px;
		}

		&::-webkit-scrollbar-track {
			background: transparent;
		}
	}

	tbody {
		tr {
			transition: 0.2s;

			&:hover {
				td {
					background: #f4dc58;
				}
			}
		}
	}

	td {
		padding: 12px 8px;
		text-align: center;
		font-size: 14px;
		font-weight: 500;
		color: #2d3340;
		vertical-align: middle;
		background: #d9d6f8;
		border-bottom: 1px solid rgba(255, 255, 255, 0.7);
		transition: 0.2s;

		&:nth-child(1) {
			width: 40%;
		}

		&:nth-child(2) {
			width: 35%;
		}

		&:nth-child(3) {
			width: 25%;
		}
	}

	.prize {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 6px;

		img {
			width: 50px;
			height: 50px;
			object-fit: contain;
		}

		span {
			font-size: 14px;
			font-weight: 700;
			line-height: 1.2;
			text-align: center;
			word-break: break-word;
		}
	}

	@media (max-width: 768px) {
		.table-body {
			max-height: 250px;
		}

		th,
		td {
			font-size: 12px;
		}

		.prize {
			img {
				width: 40px;
				height: 40px;
			}

			span {
				font-size: 12px;
			}
		}
	}
	}

	.description{
		text-align: center;
		margin-top: 10px;
		p{
			font-size: 14px;
			font-weight: 500;
			color: #fff;
			font-style: italic;
			margin: 0;
			line-height: 140%;
		}
	}
}
`
